<template>
  <div class="rules">
    <div class="title"><img src="../../assets/rules.png" /></div>
    <div>

      <div class="texttitle">比赛分组</div>
      <div>
        <div class="line"><img src="../../assets/right.png" />
          <div class="linetitle">股票策略</div>
          <div class="linetext">主要投资于股票市场，且总头寸占比超60%</div>
        </div>
        <div class="line"><img src="../../assets/right.png" />
          <div class="linetitle">对冲策略</div>
          <div class="linetext">同时持有资产相关、规模相当的多空头寸策略，且总头寸占比超60%</div>
        </div>
        <div class="line"><img src="../../assets/right.png" />
          <div class="linetitle">CTA及衍生品策略</div>
          <div class="linetext">主要投资于商品及金融衍生品，且投资比例超60%</div>
        </div>
        <div class="line"><img src="../../assets/right.png" />
          <div class="linetitle">混合策略</div>
          <div class="linetext">采用多种投资策略，且每种策略的投资比例不超过60%</div>
        </div>
        <div class="line"><img src="../../assets/right.png" />
          <div class="linetitle">其他策略</div>
          <div class="linetext">包括固收、日内等其他各种策略</div>
        </div>
      </div>
      <div class="texttitle">评分方法</div>
      <div class="pfff">评分标准分为两部分，净值及其他风险指标评分占比80%；专家评分20%（以大赛最终活动页面详细规则为准）</div>
    </div>
    <singup></singup>
  </div>
</template>
<script>
import singup from "../common/singup.vue"
export default {
  components:{
    singup
  }
}
</script>
<style scoped>
  .rules {
    height: 100%;
    background: url("../../assets/rulessettingbg.png") no-repeat center;
    background-size: cover;
    position: relative;
  }
  .title {
    text-align: center;
    padding-top: 6vh;
  }
  .title img {
    width: 43%;
  }
  .texttitle {
     text-align: center;
     font-size: 4.5vw;
     color: #86D4F8;
     /* background-image: -webkit-linear-gradient(#fff, #86D4F7);
     background-image: -o-linear-gradient(#fff, #86D4F7);
     background-image: -moz-linear-gradient(#fff, #86D4F7);
     background-image: linear-gradient(#fff, #86D4F7);
     -webkit-background-clip: text;
     -o-background-clip: text;
     -moz-background-clip: text;
     background-clip: text;
     -webkit-text-fill-color: transparent;
     -o-text-fill-color: transparent;
     -moz-text-fill-color: transparent;
     text-fill-color: transparent; */
     padding: 0vw 0 2vw 0;
    font-weight: bold;
   }
  .line {
    width: 84vw;
    margin: 0 6vw 0 10vw;
    position: relative;
    padding-bottom: 3vw;
  }
  .line img {
    position: absolute;
    width: 2vw;
    left: -3vw;
    top: 1.8vw;
  }
  .linetitle {
    color: #86b6f8;
    font-size: 4vw;
    padding: 1vw 0;
  }
  .linetext {
    color: #fff;
    font-size: 3.5vw;
  }
  .pfff {
    color: #fff;
    width: 88vw;
    font-size: 3.5vw;
    text-indent: 6vw;
    padding: 0 6vw;
    line-height: 5vw;
  }
</style>



// WEBPACK FOOTER //
// src/components/page/rules.vue